import { Component, type ReactNode } from 'react'

interface Props {
  children: ReactNode
}
interface State {
  hasError: boolean
}

// Catches render errors so a crash shows a friendly retry screen instead of a
// blank white page. Wraps the whole app.
export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: unknown, info: unknown) {
    console.error('Render error:', error, info)
  }

  render() {
    if (!this.state.hasError) return this.props.children

    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
        <p className="text-lg font-bold text-ink-900">حدث خطأ ما · Une erreur est survenue</p>
        <p className="max-w-sm text-sm text-ink-500">
          يرجى إعادة تحميل الصفحة · Veuillez recharger la page
        </p>
        <button
          onClick={() => window.location.reload()}
          className="rounded-xl bg-ink-900 px-5 py-2.5 text-sm font-semibold text-white hover:bg-ink-800"
        >
          إعادة التحميل · Recharger
        </button>
      </div>
    )
  }
}
